import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useState } from "react";

const PRIMARY = "#CC0000";

const navItems = [
  { label: "Top", path: "/" },
  { label: "Company", path: "/company" },
  { label: "Service", path: "/service" },
  { label: "News", path: "/news" },
  { label: "Contact", path: "/contact" },
];

function Header() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  return (
    <AppBar position="sticky" elevation={0} sx={{ bgcolor: "#fff", borderBottom: "2px solid " + PRIMARY }}>
      <Toolbar sx={{ minHeight: { xs: 64, md: 72 } }}>
        {/* ロゴ */}
        <Box
          component={RouterLink}
          to="/"
          sx={{ display: "flex", alignItems: "center", textDecoration: "none" }}
        >
          <Box
            component="img"
            src="/logo.svg"
            alt="TriArrows"
            sx={{ height: 48, width: "auto", mr: 1 }}
          />
          <Typography
            sx={{
              fontWeight: 900,
              fontSize: { xs: "1.1rem", md: "1.3rem" },
              color: PRIMARY,
              letterSpacing: 1,
              display: { xs: "none", sm: "block" },
            }}
          >
            TriArrows
          </Typography>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        {/* PC ナビ */}
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 4 }}>
          {navItems.map((item) => {
            const active = location.pathname === item.path;
            return (
              <Typography
                key={item.label}
                component={RouterLink}
                to={item.path}
                sx={{
                  color: active ? PRIMARY : "#333",
                  fontWeight: active ? 700 : 500,
                  textDecoration: "none",
                  fontSize: "0.95rem",
                  borderBottom: active ? `2px solid ${PRIMARY}` : "2px solid transparent",
                  pb: 0.5,
                  transition: "color 0.2s",
                  "&:hover": { color: PRIMARY },
                }}
              >
                {item.label}
              </Typography>
            );
          })}
        </Box>

        {/* モバイル ハンバーガー */}
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: PRIMARY }}>
            <MenuIcon />
          </IconButton>
        </Box>
      </Toolbar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { width: 240 } }}
      >
        <Box sx={{ bgcolor: PRIMARY, py: 3, px: 2 }}>
          <Typography sx={{ color: "#fff", fontWeight: 900, fontSize: "1.2rem" }}>
            TriArrows
          </Typography>
        </Box>
        <List>
          {navItems.map((item) => (
            <ListItem
              button
              key={item.label}
              component={RouterLink}
              to={item.path}
              onClick={() => setDrawerOpen(false)}
              sx={{ "&:hover": { bgcolor: "#ffeaea" } }}
            >
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{ fontWeight: 600, color: "#333" }}
              />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </AppBar>
  );
}

export default Header;
